<template>
  <div class="page-container row">
    <div class="col-6">
      <b-card bg-variant="light" text-variant="dark" title="Samodzielny konsultant">
        <b-card-text>
          Wybierz tą opcje jeżeli chcesz utworzyć samodzielne konto konsultanta, który nie jest
          podrzędny żadnej organizacji.
        </b-card-text>
        <b-button @click="standalone" variant="primary">Wybierz</b-button>
      </b-card>
    </div>
    <div class="col-6">
      <b-card bg-variant="light" text-variant="dark" title="Konsultant podpięty pod organizacje">
        <b-card-text>
          Wybierz tą opcje jeżeli chcesz utworzyć konto konsultanta, który będzie podrzedny koncie
          organizacji.
        </b-card-text>
        <b-form-group
          id="input-group-license"
          label="Wybór organizacji:"
          label-for="input-license"
          description="Konto konsultanta zostanie podpiętę pod konto tej organizacji."
        >
          <b-form-select v-model="organization" :options="organizations"></b-form-select>
        </b-form-group>
        <b-button @click="withOrganization" variant="primary" :disabled="organization === null"
          >Wybierz</b-button
        >
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultantType',
  created() {
    this.fetchOrganizations()
  },
  data() {
    return {
      organization: null,
      organizations: []
    }
  },
  methods: {
    standalone() {
      this.$router.push({ name: 'e-zacma-add-doctor' })
    },
    withOrganization() {
      const vm = this
      vm.$router.push({ name: 'e-zacma-add-doctor', params: { organizationId: vm.organization } })
    },
    fetchOrganizations() {
      const vm = this
      vm.$http
        .post('e-zacma/organization/all')
        .then(response => {
          vm.refactor(response.data)
        })
        .catch(() => {
          vm.$toast.error({
            message: 'Wystapił błąd podczas próby pobrania listy organizacji.'
          })
        })
        .then(() => {
          vm.$store.commit('removePageLoaderEvent', 'list-visit-type-groups')
        })
    },
    refactor(organizations) {
      const vm = this
      // eslint-disable-next-line no-restricted-syntax
      for (const organization of organizations) {
        vm.organizations.push({
          value: organization.id,
          text: organization.name
        })
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
